'use client';

import { useEffect, useState, type ReactNode } from 'react';
import { CartProvider } from 'react-use-cart';
import { WorkspaceProvider } from '@/contexts/workspace-context';

function BrowserCartProvider({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return <>{children}</>;

  return <CartProvider id="ace-cart">{children}</CartProvider>;
}

const AccountProviders = ({ children }: { children: ReactNode }) => {
  return (
    <WorkspaceProvider>
      <BrowserCartProvider>{children}</BrowserCartProvider>
    </WorkspaceProvider>
  );
};

export default AccountProviders;
